module.exports = "/wwwroot/img/service_map_embed_block.png?ver=7594d3b7";